import { useState } from "react";
import { authenticatedApi } from "api";
import DeleteButton from "@components/DeleteButton";
import { useDeleteReport } from "@api/reportService";
import toast from "react-hot-toast";

export const ReportDeleteButton = ({report, ...props}) => {
    const deleteObject = useDeleteReport({id: report.id});

    const onConfirm = () => {
        const performDelete = deleteObject.mutateAsync();

        toast.promise(performDelete, {
            loading: 'Deleting...',
            success: `The report was deleted.`,
            error: 'There was an error while deleting.',
        });
    };

    return (
        <DeleteButton
            onDelete={onConfirm}
            tooltip={'Delete Saved Report'}
            content={<>Are you sure you want to delete this saved report?</>}
            color="danger"
            variant="solid"
            sx={{
                '--IconButton-size': '1.5rem',
                verticalAlign: 'sub',
                // ml: 0.5,
                bgcolor: 'danger.500',
                'svg': {
                    width: '1.05rem',
                    height: '1.05rem',
                }
            }}
            {...props}
        />
    );
}
